'use strict';

// Selective disclosure — "share what you choose." The user signs exactly the facts they pick
// (label → value) with their identity key, bound to an optional audience + expiry. The recipient
// can confirm the card came from that DID and was not altered or revoked. Same rails as docsign:
// a self-signed VC over a small claim set. (Self-asserted; issuer-verified chips stay separate.)

const vcjwt = require('./vcjwt');

/**
 * @param {object} o - { did, privateKey (bsv), fields: {label:value}, audience?, ttlDays? }
 * @returns a SelfDisclosure VC-JWT (ES256K), subject = the holder's own DID.
 */
function createDisclosure({ did, privateKey, fields, audience, ttlDays }) {
  const issuedAt = Math.floor(Date.now() / 1000);
  const expiresAt = ttlDays ? issuedAt + Math.round(ttlDays * 86400) : null;
  return vcjwt.issueVc({
    issuerDid: did,
    kid: 'key-1',
    privateKey,
    subjectId: did,
    type: 'SelfDisclosure',
    claims: { fields: fields || {}, audience: audience || null, issuedAt, expiresAt },
  });
}

module.exports = { createDisclosure };
